import { apiClient, getErrorMessage } from './apiClient'
import type { User } from '../types'

export interface LoginRequest {
  email: string
  password: string
}

export interface LoginResponse {
  user: {
    id: string
    email: string
    name: string
    role: string
  }
  accessToken: string
  refreshToken: string
}

export interface RegisterRequest {
  email: string
  password: string
  name: string
  role?: 'admin' | 'vendedor' | 'gerente'
}

export const authService = {
  async login(credentials: LoginRequest): Promise<{ user: User; token: string }> {
    console.log('🌐 authService.login() - Fazendo requisição HTTP para:', '/auth/login')
    console.log('📧 Email:', credentials.email)
    
    try {
      const response = await apiClient.post<LoginResponse>('/auth/login', credentials)
      console.log('✅ Resposta HTTP recebida:', response.status)
      console.log('👤 Dados do usuário:', {
        id: response.data.user.id,
        name: response.data.user.name,
        email: response.data.user.email,
        role: response.data.user.role,
      })
      
      return {
        user: {
          id: response.data.user.id,
          email: response.data.user.email,
          name: response.data.user.name,
          token: response.data.accessToken,
          role: response.data.user.role as 'admin' | 'vendedor' | 'operador',
        },
        token: response.data.accessToken,
      }
    } catch (error) {
      console.error('❌ Erro HTTP na requisição de login:', error)
      throw new Error(getErrorMessage(error))
    }
  },

  async register(data: RegisterRequest): Promise<{ user: User; token: string }> {
    try {
      const response = await apiClient.post<LoginResponse>('/auth/register', data)
      return {
        user: {
          id: response.data.user.id,
          email: response.data.user.email,
          name: response.data.user.name,
          token: response.data.accessToken,
          role: response.data.user.role as 'admin' | 'vendedor' | 'operador',
        },
        token: response.data.accessToken,
      }
    } catch (error) {
      throw new Error(getErrorMessage(error))
    }
  },

  async logout(): Promise<void> {
    console.log('🌐 authService.logout() - Fazendo requisição HTTP')
    try {
      await apiClient.post('/auth/logout')
      console.log('✅ Logout HTTP bem-sucedido')
    } catch (error) {
      console.error('❌ Erro ao fazer logout:', error)
      throw error // Propaga erro para tratamento no store
    }
  },

  async refreshToken(refreshToken: string): Promise<string> {
    try {
      const response = await apiClient.post<{ accessToken: string }>('/auth/refresh', {
        refreshToken,
      })
      return response.data.accessToken
    } catch (error) {
      throw new Error(getErrorMessage(error))
    }
  },
}
